import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    reference: {
      type: String,
      required: true,
    },
    showBanner: {
      type: Boolean,
      default: false,
    },
    productTile: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    newPage: {
      type: Boolean,
      default: false,
      required: false,
    },
    tracking: {
      type: Object,
      default: null,
    },
    dataCy: {
      type: String,
      default: 'wishlist-button',
    },
    defaultInWishlistIcon: {
      type: String,
      default: 'heart-full',
    },
    internalReference: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      defaultIcon: 'heart',
    };
  },

  computed: {
    ...mapGetters('wishlist', ['isInWishlist']),

    icon() {
      return this.isInWishlist(this.reference) ? this.defaultInWishlistIcon : this.defaultIcon;
    },

    ariaLabel() {
      return this.isInWishlist(this.reference)
        ? this.$t('Accessibility.removeFromWishlist', { name: this.name })
        : this.$t('Accessibility.AddToWishlist', { name: this.name });
    },
  },

  methods: {
    ...mapActions('wishlist', ['toggleProduct']),

    async toggleWishlistProduct() {
      const productIsAlreadyInWishlist = this.isInWishlist(this.reference);

      const added = await this.toggleProduct({
        reference: this.reference,
        internalReference: this.internalReference,
        showBanner: this.showBanner,
      });

      if (!productIsAlreadyInWishlist && added) {
        window.tracking.pushAddToWishlistTracking(this.tracking);
      }
    },
  },
};
